module.exports = __webpack_public_path__ + "static/img/CMI5.7fd5e5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CMI5.jpg
// module id = 6mi2
// module chunks = 0